import { Injectable, inject } from '@angular/core';

import { Actions } from '@ngrx/effects';
import { of } from 'rxjs';
import { map, mergeMap } from 'rxjs/operators';

import { createEffectFactory } from '@core/ngrx-legacy';

import { JobsBriefActions } from './jobs-brief.store';
import { OfferScope } from '../../../types';
import { JobsHttpService } from '../jobs-http.service';

@Injectable({
  providedIn: 'root',
})
export class JobsBriefEffects {
  private readonly jobsHttpService = inject(JobsHttpService);
  private readonly actions$ = inject(Actions);

  public effects = createEffectFactory(JobsBriefActions, this.actions$);

  public fetchActiveCollection$ = this.effects(JobsBriefActions.fetchActiveCollection, () =>
    of(JobsBriefActions.fetchCollection({ payload: { scope: OfferScope.Active } })),
  );

  public fetchArchivedCollection$ = this.effects(JobsBriefActions.fetchArchivedCollection, () =>
    of(JobsBriefActions.fetchCollection({ payload: { scope: OfferScope.Archived } })),
  );

  public fetchCollection$ = this.effects(
    JobsBriefActions.fetchCollection,
    ({ payload }) =>
      this.jobsHttpService.fetchBriefCollection$(payload!.scope).pipe(
        map(response => ({
          data: response.offers,
          scope: payload!.scope,
        })),
      ),
    {
      customMapOperator: mergeMap,
    },
  );
}
